import { forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";

function CurrentPrice(props, ref) {

    useImperativeHandle(ref, () => ({
        getName: getName,
        getType: getType,
        getTitle: getTitle,
        hasSettings: hasSettings,
        getSettings: getSettings,
        getDefaultOptions: ({ createOrUpdate }) => ({})
    }));

    const getName = () => {
        return 'Единична цена с ДДС';
    }

    const getType = () => {
        return 'current_price';
    }

    const getTitle = () => {
        return null;
    }

    const hasSettings = () => false;

    const getSettings = ({ state, setConfig, createOrUpdate }) => {
        return null;
    }

    return getName();
}

export default forwardRef(CurrentPrice)